<script lang="ts">
	import P from "#lib/components/P.svelte";

	interface Props {
		text: string;
	}

	let { text }: Props = $props();
</script>

<div class="mt-2 mb-4 flex w-full items-center justify-center">
	<hr class="grow border-t border-gray-300" />
	<P size="sm" class="px-2 text-gray-400">{text}</P>
	<hr class="grow border-t border-gray-300" />
</div>
